
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Methodik`}</strong>{`
Basierend auf dem mit seiner Kollegin Dai-Hua Tsai erschaffenen Modell, entwickelte Arbeitshygieniker Michael Riediker zusammen mit Christian Monn vom Staatssekretariat für Wirtschaft (Seco) einen `}<a parentName="p" {...{
        "href": "https://scoeh.ch/de/tools/"
      }}>{`Simulator`}</a>{` ohne Interface, mit welchem berechnet werden kann, wie sich virusbelastete Aerosole in Räumen anreichern.`}</p>
    <p>{`Im Vergleich zur Atmung erhöht leises Sprechen die Menge an Schwebeteilchen etwa um das Zehnfache, lautes Sprechen und Singen steigern die Zahl weiter. «Auch beim Sport können sich die Emissionen leicht verdoppeln bis vervierfachen», so Riediker. «Etwa 50 Prozent der infizierten Bevölkerung geben inzwischen so viele Viren ab, dass ein realistisches Ansteckungsrisiko besteht, insbesondere wenn sie in kleinen, schlecht belüfteten Räumen laut und lange sprechen.» Seit der Delta-Variante sei einer von 30 Infizierten mit oder ohne Symptome ein Superemitter und könne selbst in sehr grossen Hallen andere infizieren – vor Delta habe sei dies nur auf eine von 1000 Personen zugetroffen. Dann kann es gemäss den Berechnungen auch bei normaler Atmung zu einer Ansteckung kommen, wenn eine Person eine Stunde im gleichen Raum ist.`}</p>
    <p>{`Wie ansteckend erwachsene Personen sind, wurde mittels publizierten Zahlen von Virenkopien bestimmt mit PCR-Tests und Aerosolemissionen modelliert. Eine detaillierte Beschreibung des Tools gibt es auf Riedikers `}<a parentName="p" {...{
        "href": "https://scoeh.ch/en/variation-of-virus-aerosol-emissions-in-the-infected-population-and-a-tool-to-rapidly-simulate-the-airborne-virus-exposures-in-different-indoor-scenarios/"
      }}>{`Blog`}</a>{`. `}</p>
    <p>{`Die Tools wurden mit grosser Sorgfalt erstellt und im Detail überprüft, können jedoch Fehler enthalten. Verwenden Sie das Tool nicht als alleiniges Instrument für kritische Entscheidungen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;